import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, AbstractControl, ValidationErrors } from '@angular/forms'; 
import { CustomSnackbarService } from '../../custom-notification/custom-notification.component';
import { ProductListingService } from '../../../service/product-listing.service';


@Component({
  selector: 'app-add-product',
  templateUrl: './add-product.component.html',
  styleUrls: ['./add-product.component.css']
})

export class AddProductComponent implements OnInit {
  form!: FormGroup;

  constructor(private fb: FormBuilder, private productListingService: ProductListingService, private customSnackbarService: CustomSnackbarService) { }

  @Input() isLocalBusinessProductAddView: boolean = false;
  @Input() formTitle: string = '';
  @Output() resetListing = new EventEmitter<void>();
  @Output() close = new EventEmitter<void>();

  categoryList: any = {
    loading: false,
    response: null,
    error: ''
  };
  subCategoryList: any = {
    loading: false,
    response: null,
    error: ''
  };
  subCategoryVarientList: any = {
    loading: false,
    response: null,
    error: ''
  };
  availableBranches: any = {
    loading: false,
    response: null,
    error: ''
  };
  weightUnitList: any = {
    loading: false,
    response: null,
    error: ''
  };
  delDistanceList: any = {
    loading: false,
    response: null,
    error: ''
  };
  prodTypeList: any = {
    loading: false,
    response: null,
    error: ''
  };
  packingTypeList: any = {
    loading: false,
    response: null,
    error: ''
  };
  stockStatusList: any = {
    loading: false,
    response: null,
    error: ''
  };
  statusList: any = {
    loading: false,
    response: null,
    error: ''
  };
  allowedFileSizeToUpload: number = 2; //size in MB
  uploadingFile: boolean = false;
  uploadingMediaIndex:number|null=null;
  uploadingVarientMediaIndex:number|null=null;
  submitLoading: boolean = false;
  ngOnInit() {
    this.form = this.fb.group({
      id: [null],
      productId: [null],
      // statusId: [1],
      productName: ['', [Validators.required, Validators.maxLength(64)]],
      categoryId: ['', Validators.required],
      subCategoryId: ['', Validators.required],
      description: ['', Validators.required],
      shopifyLink: ['', Validators.pattern('https?://.+')],
      weight: [null],
      weightUnitId: [''],
      delDistanceId: ['', Validators.required],
      productTypeId: ['', Validators.required],
      packingTypeId: [''],
      mediaList: this.fb.array([this.fb.control("", Validators.required), this.fb.control(""), this.fb.control(""), this.fb.control("")]),
      variantList: this.fb.array([this.createVariantGroup()])
    });

    this.getProductCategories()
    this.getProductWeightUnits()
    this.getProductDeliveryDistance()
    this.getProductTypes()
    this.getPackagingTypes()
    this.getStockStatus()
    this.getProductStatus()

    if (this.isLocalBusinessProductAddView) {
      this.getAllAvailableBranches()
    }

    this.form.get('categoryId')?.valueChanges.subscribe(newCategoryValue => {
      // Handle changes here
      this.form.get('subCategoryId')?.setValue('')
      this.subCategoryVarientList = {
        loading: false,
        response: null,
        error: ''
      }
      this.resetVariantList();
      this.getSubCategories(newCategoryValue)
    });

    this.form.get('subCategoryId')?.valueChanges.subscribe(value => {
      // Handle changes here
      this.resetVariantList();
      this.getSubCategoryVarients(value)
    });
  }

  resetVariantList() {
    const variantList = this.form.get('variantList') as FormArray;
    while (variantList.length !== 0) {
      variantList.removeAt(0);
    }
    variantList.push(this.createVariantGroup());
  }
  // Convenience getters for easy access to form arrays and controls
  get mediaList(): FormArray {
    return this.form.get('mediaList') as FormArray;
  }

  get variantList(): FormArray {
    return this.form.get('variantList') as FormArray;
  }

  get variantControls(): FormGroup[] {
    return (this.form.get('variantList') as FormArray).controls as FormGroup[];
  }

  createVariantGroup(): FormGroup {
    return this.fb.group({
      id: [null],
      sku: [''],
      price: ['', [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      discountedPrice: ['', [Validators.pattern(/^\d+(\.\d{1,2})?$/)]],
      quantity: ['', [Validators.pattern(/^\d+$/)]],
      statusId: ['', Validators.required],
      stockStatusId: ['', Validators.required],
      variantId1: [this.subCategoryVarientList.response?.[0]?.id || null],
      variantId2: [this.subCategoryVarientList.response?.[1]?.id || null],
      variantId3: [this.subCategoryVarientList.response?.[2]?.id || null],
      variantOption1: [null],
      variantOption2: [null],
      variantOption3: [null],
      mediaList: this.fb.array([this.fb.control({ src: "" })])
    });
  }

  addMedia() {
    this.mediaList.push(this.fb.control({ src: "" }, Validators.required));
  }


  // Accessor for the mediaList FormArray
  get mediaListt() {
    return (this.form.get('mediaList') as FormArray).controls;
  }
  addMediaAtIndex(mediaIndex: number, updatedObject: any) {
    if (mediaIndex >= 0 && mediaIndex <= this.mediaListt.length) {
      (this.form.get('mediaList') as FormArray).at(mediaIndex).patchValue(updatedObject);
    }
  }

  removeMedia(mediaIndex: number) {
    // this.mediaList.removeAt(index);
    if (mediaIndex >= 0 && mediaIndex <= this.mediaListt.length) {
      (this.form.get('mediaList') as FormArray).at(mediaIndex).patchValue("");
    }
  }

  resetFileInput(event: any) {
    const fileInput = event.nativeElement;
    const newFileInput = document.createElement('input');
    newFileInput.type = 'file';
    newFileInput.id = fileInput.id;

    // Copy any other attributes you may need

    fileInput.parentNode.replaceChild(newFileInput, fileInput);
    event.nativeElement = newFileInput;
  }

  addVariant() {
    this.variantList.push(this.createVariantGroup());
  }

  removeVariant(index: number) {
    this.variantList.removeAt(index);
  }

  addVariantMedia(variantIndex: number, media: { src: string }) {
    const mediaList = (this.variantControls[variantIndex].get('mediaList') as FormArray);
    while (mediaList.length !== 0) {
      mediaList.removeAt(0);
    }
    mediaList.push(this.fb.control(media, Validators.required));
  }

  removeVariantMedia(variantIndex: number, mediaIndex: number) {
    const mediaList = (this.variantControls[variantIndex].get('mediaList') as FormArray);
    mediaList.removeAt(mediaIndex);
    mediaList.push(this.fb.control({ src: "" },));
  }

  handleReset() {
    // this.form.reset()
    this.close.emit()
    // this.form.get('statusId')?.setValue(1)
  }


  getAllAvailableBranches() {
    this.availableBranches = {
      ...this.availableBranches,
      loading: true,
      error: ''
    }
    this.productListingService.getAvailableBranch().then((res: any) => {
      this.availableBranches = {
        ...this.availableBranches,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.availableBranches = {
        ...this.availableBranches,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }


  getProductCategories() {
    this.categoryList = {
      ...this.categoryList,
      loading: true,
      error: ''
    }
    this.productListingService.getProductCategories().then((res: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.categoryList = {
        ...this.categoryList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }


  getProductWeightUnits() {
    this.weightUnitList = {
      ...this.weightUnitList,
      loading: true,
      error: ''
    }
    this.productListingService.getWeightUnits().then((res: any) => {
      this.weightUnitList = {
        ...this.weightUnitList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.weightUnitList = {
        ...this.weightUnitList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getProductDeliveryDistance() {
    this.delDistanceList = {
      ...this.delDistanceList,
      loading: true,
      error: ''
    }
    this.productListingService.getDelDistance().then((res: any) => {
      this.delDistanceList = {
        ...this.delDistanceList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.delDistanceList = {
        ...this.delDistanceList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getProductTypes() {
    this.prodTypeList = {
      ...this.prodTypeList,
      loading: true,
      error: ''
    }
    this.productListingService.getProductTypes().then((res: any) => {
      this.prodTypeList = {
        ...this.prodTypeList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.prodTypeList = {
        ...this.prodTypeList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getPackagingTypes() {
    this.packingTypeList = {
      ...this.packingTypeList,
      loading: true,
      error: ''
    }
    this.productListingService.getPackageType().then((res: any) => {
      this.packingTypeList = {
        ...this.packingTypeList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.packingTypeList = {
        ...this.packingTypeList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getStockStatus() {
    this.stockStatusList = {
      ...this.stockStatusList,
      loading: true,
      error: ''
    }
    this.productListingService.getStockStatus().then((res: any) => {
      this.stockStatusList = {
        ...this.stockStatusList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.stockStatusList = {
        ...this.stockStatusList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getProductStatus() {
    this.statusList = {
      ...this.statusList,
      loading: true,
      error: ''
    }
    this.productListingService.getProductStatus().then((res: any) => {
      this.statusList = {
        ...this.statusList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.statusList = {
        ...this.statusList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getSubCategories(catId: string) {
    if (!catId) {
      return
    }
    this.subCategoryList = {
      ...this.subCategoryList,
      response: null,
      loading: true,
      error: ''
    }
    this.productListingService.getProductSubCategories(catId).then((res: any) => {
      this.subCategoryList = {
        ...this.subCategoryList,
        loading: false,
        response: res.data.data,
      }
    }).catch((err: any) => {
      this.subCategoryList = {
        ...this.subCategoryList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }

  getSubCategoryVarients(subCatId: string) {
    if (!subCatId) {
      return
    }
    this.subCategoryVarientList = {
      ...this.subCategoryVarientList,
      response: null,
      loading: true,
      error: ''
    }
    this.productListingService.getSubCategoryVarients(subCatId).then((res: any) => {
      const variants = res.data.data;
      let varientsOptions = variants.map((l: any) => {
        return this.productListingService.getVarientOptions(l.id).then((vor: any) => ({
          ...l,
          options: vor.data.data
        })).catch(() => ([]))
      })
      Promise.all(varientsOptions).then(vo => {
        this.subCategoryVarientList = {
          ...this.subCategoryVarientList,
          loading: false,
          response: vo,
        }
        this.resetVariantList()
      })
    }).catch((err: any) => {
      this.subCategoryVarientList = {
        ...this.subCategoryVarientList,
        loading: false,
        response: null,
        error: err.response.statusText
      }
    })
  }
  allowOnlyNumeric(event: KeyboardEvent) {
    // Allow backspace
    if (event.key === 'Backspace') {
      return true;
    }

    // Allow only numeric digits
    const isNumeric = /^\d$/.test(event.key);

    if (!isNumeric) {
      event.preventDefault();
      return false;
    }

    return true; // This line is necessary for TypeScript to be satisfied
  }


  uploadFile(value: any, type: string, index: number) {
    const selectedFile = value.files[0];
    console.log(selectedFile, 'selectedFilekkk')
    const maxSizeInBytes = this.allowedFileSizeToUpload * 1024 * 1024; // 2MB (adjust to your maximum size)
    if (selectedFile.type === "image/png" || selectedFile.type === "image/jpg" || selectedFile.type === "image/jpeg") {

      if (selectedFile && selectedFile.size > maxSizeInBytes) {
        this.customSnackbarService.openCustomSnackbar(`File size must be less than ${this.allowedFileSizeToUpload} MB`, 30000, true);
        return
      }

      if(type === "varient"){
       this.uploadingVarientMediaIndex = index;
      }
      if(type === "media"){
        this.uploadingMediaIndex = index;
      }
      this.uploadingFile = true;
      let formData: FormData = new FormData();
      formData.append('files', value.files[0]);
      formData.append('type', 'ProductMedia')

      this.productListingService.uploadFile(formData).then((res: any) => {
        if (res.data.status === "SUCCESS") {
          if (type === 'varient') {
            this.addVariantMedia(index, { src: res.data.data.documentUri })
          }
          if (type === "media") {
            this.addMediaAtIndex(index, { src: res.data.data.documentUri })
          }
          this.uploadingFile = false;
          this.uploadingVarientMediaIndex = null;
          this.uploadingMediaIndex = null;
        }
      }).catch((error: any) => {
        this.uploadingVarientMediaIndex = null;
        this.uploadingMediaIndex = null;
        this.uploadingFile = false;
        this.customSnackbarService.openCustomSnackbar('Something is broken', 3000, true);
      })
    } else {
      this.customSnackbarService.openCustomSnackbar('Only accept .png, .jpg, .jpeg', 30000, true);

    }
  }

  onSubmit() {
    if(this.submitLoading || this.uploadingFile){
      return
    }
    if (this.form.valid) {
      // Handle form submission logic here
      this.submitLoading = true;
      this.form.value.mediaList = this.form.value.mediaList.filter((l:any)=>l)
      this.form.value.variantList = this.form.value.variantList.map((l:any)=>({...l, sku: l.sku ? l.sku : null}))
      this.productListingService.saveProduct(this.form.value).then((res: any) => {
        if (res.data.status === "SUCCESS") {
          this.resetListing.emit()
          this.submitLoading = false;
          if (this.form.value.productId) {
            this.customSnackbarService.openCustomSnackbar('The product has been updated successfully.', 30000);
          } else {
            this.customSnackbarService.openCustomSnackbar('The product has been added successfully.', 30000);
          }
        }
      }).catch((error: any) => {
        this.submitLoading = false;
        this.customSnackbarService.openCustomSnackbar('Something is broken', 3000, true);
      })
    } else {
      console.log(this.form);
      // Mark all controls as touched to display validation messages
      this.form.markAllAsTouched();
    }
  }
}
